import { render, staticRenderFns } from "./BudgetDetailsCard.vue?vue&type=template&id=b507b0ca&scoped=true"
import script from "./BudgetDetailsCard.vue?vue&type=script&lang=js"
export * from "./BudgetDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./BudgetDetailsCard.vue?vue&type=style&index=0&id=b507b0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b507b0ca",
  null
  
)

export default component.exports